import { DATE_FORMAT_GETTER } from '@/Modules/Base/SettingModule.js'
import store from '@/Setup/SetupStore.js'
import moment from 'moment'

export default {
  data() {
    return {
      entities: [],
      users: [],
    }
  },

  async created() {
    this.$nextTick(() => this.errors.clear())

    if (!this.activity.id) {
      const dateFormat = store.getters[`SettingModule/${DATE_FORMAT_GETTER}`]

      this.activity.activityDate = moment().format(dateFormat)
    }
  },

  methods: {
    getPayload() {
      return {
        subject: this.activity.subject,
        type: this.$selectValue(this.activity, 'type'),
        priority: this.$selectValue(this.activity, 'priority'),
        description: this.activity.description,
        activityDate: this.activity.activityDate,
        entityId: this.$selectValue(this.activity, 'entityId'),
        userId: this.$selectValue(this.activity, 'userId'),
      }
    },
  },
}
